import { TaskHeaderLayoutType, TaskHeaderType } from './task-object.types';

export class SetTaskObjectState {
  static readonly type = '[Task] Set Task Object State';
  constructor(public entities: any) {}
}

export class ResetState {
  static readonly type = '[Task] Reset State';
  constructor() {}
}

export class ResetTask {
  static readonly type = '[Task] Reset Task';
  constructor() {}
}

export class PrepareRequest {
  static readonly type = '[Task] Prepare Request';
  constructor(public tranOptions: any) {}
}

export class UpdateTask {
  static readonly type = '[Task] Update Task';
  constructor(public task: any) {}
}

export class SetCurrentReference {
  static readonly type = '[Task] Set Current Reference';
  constructor(public task: any) {}
}

export class NewTask {
  static readonly type = '[Task] New Task';
  constructor(public taskDefaults: any) {}
}

export class CloneTask {
  static readonly type = '[Task] Clone Task';
  constructor() {}
}

export class UpdateProject {
  static readonly type = '[Task] Update Project';
  constructor(public project: any) {}
}

export class SuppressTaskHeader {
  static readonly type = '[Task] SuppressTaskHeader';
  constructor(public on: boolean) {}
}

export class SetTaskReference {
  static readonly type = '[Task] Set Task Reference';
  constructor(public task: any, public refData: any, public refType: any) {}
}

export class SetCurrentTaskHeaderLayout {
  static readonly type = '[Task] Set Current Task Header Layout';
  constructor(public taskHeaderLayout: TaskHeaderLayoutType) {}
}

export class UpdateTaskHeader {
  static readonly type = '[Task] Update Task Header';
  constructor(public taskHeader: TaskHeaderType) {}
}

export class SetProjectState {
  static readonly type = '[Task] Set Project State';
  constructor(public project: any) {}
}

export class AddTaskToQueue {
  static readonly type = '[Task] Add Task to Auto Open Queue';
  constructor(public task: any) {}
}

export class RemoveTaskFromQueue {
  static readonly type = '[Task] Remove Task from Auto Open Queue';
  constructor(public taskID: number) {}
}

export class NotifyDocumentSaved {
  static readonly type = '[Task] Notify Document Saved';
  constructor() {}
}

export class SetCurrentReferenceContract {
  static readonly type = '[Task] Set Current Reference Contract';
  constructor(public contract: any) {}
}
